import { Controller, type UseFormReturn } from "react-hook-form";
import type { CreateProductionOrderRequest } from "@opus-dt/shared-types";
import { DateTimeField } from "@/components/ui/datetime-field";
import { DueDateNotice } from "./DueDateNotice";

// Prazo do cliente no formulário de OP. Fica FORA da grade de datas do plano
// (início/fim/quantidade) de propósito: prazo é compromisso COMERCIAL, não parâmetro de produção —
// separá-lo evita que pareça mais um campo obrigatório da janela. O aviso ocupa a folga da linha,
// aparecendo ao lado do campo assim que a combinação prazo × fim planejado vira atraso.
export function DueDateField({ form }: { form: UseFormReturn<CreateProductionOrderRequest> }) {
  const { control, watch } = form;
  return (
    <div className="grid gap-3 md:grid-cols-3">
      <Controller
        control={control}
        name="dueDate"
        render={({ field }) => (
          <DateTimeField
            id="po-due"
            label="Prazo do cliente (opcional)"
            value={field.value ?? null}
            onChange={(v) => field.onChange(v)}
          />
        )}
      />
      <div className="flex items-end md:col-span-2">
        <DueDateNotice due={watch("dueDate")} end={watch("expectedEnd")} />
      </div>
    </div>
  );
}
